export default "__VITE_ASSET__47410a81__"